module.exports = __webpack_public_path__ + "img/Hunter-nightelf-m-70.2a09810e.gif";